import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { useAuth } from '../contexts/AuthContext';
import { useNotification } from '../contexts/NotificationContext';

const Login: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, user, token } = useAuth();
  const { addNotification } = useNotification();
  const navigate = useNavigate();
  const location = useLocation();

  console.log('Login component rendering');

  useEffect(() => {
    console.log('Login component useEffect, current user:', user);
    console.log('Login component useEffect, current token:', token);
    if (user && token) {
      console.log('User is already logged in, redirecting to dashboard');
      navigate('/');
    }
  }, [user, token, navigate]);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    console.log('Login form submitted');
    setLoading(true);
    try {
      console.log('Attempting login with username:', username);
      await login(username, password);
      console.log('Login successful');
      addNotification('success', 'Login successful');
      navigate('/');
    } catch (error) {
      console.error('Login failed:', error);
      addNotification('error', 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex align-items-center justify-content-center min-h-screen">
      <Card title="Sign in" className="w-full md:w-25rem">
        <form onSubmit={handleSubmit} className="p-fluid">
          <div className="field">
            <label htmlFor="username" className="font-bold">Username</label>
            <InputText
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
              className="w-full"
            />
          </div>
          <div className="field">
            <label htmlFor="password" className="font-bold">Password</label>
            <Password
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              toggleMask
              className="w-full"
              feedback={false}
            />
          </div>
          <Button 
            type="submit" 
            label="Sign In" 
            icon="pi pi-user"
            loading={loading}
            className="mt-2"
          />
        </form>
      </Card>
    </div>
  );
};

export default Login;